const choices = {
    caseManager: "Chargé d'Affaire",
    cgp: 'Conseiller en Gestion de Patrimoine',
    cdd: 'Chargé de Développement',
};

export default choices;
